import { Box, Button, Grid } from "@itandi/itandi-bb-ui";
import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { NotificationList } from "~/components/common/notifications/settings/NotificationList";
import { NotificationModal } from "~/components/common/notifications/settings/NotificationModal";
import { useCompanyNotifications } from "~/hooks/useCompanyNotifications";
import { useStatuses } from "~/hooks/useStatuses";
import { useSubtypes } from "~/hooks/useSubtypes";
import type { NskResponse } from "~/models/Api";
import type { Notification, NotificationEdit } from "~/models/Notification";
import { isSuccess } from "~/utils/api/api_handler";
import { create, destroy, update } from "~/utils/api/CompanyNotification";
import SettingStyles from "../SettingStyle.module.scss";

export const NotificationSetting: React.FC = () => {
	const { data: notifications, mutate: mutateNotifications } =
		useCompanyNotifications().index();
	const { data: statuses } = useStatuses().index();
	const { data: subtypes } = useSubtypes().useIndex();
	const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
	const handleCreate = useCallback(
		async (notification: NotificationEdit): Promise<NskResponse> =>
			create(notification),
		[]
	);
	const handleUpdate = useCallback(
		async (
			notification: NotificationEdit,
			notificationId: number
		): Promise<NskResponse> => update(notification, notificationId),
		[]
	);
	const handleDestroy = useCallback(
		async (notification: Notification): Promise<NskResponse> =>
			destroy(notification),
		[]
	);
	const handleMutate = useCallback(async () => {
		await mutateNotifications?.();
	}, [mutateNotifications]);
	const handleAcceptSubmit = useCallback(
		async (notification: NotificationEdit): Promise<void> => {
			const response = await handleCreate(notification);
			if (isSuccess(response)) {
				await handleMutate();
				setIsNotificationModalOpen(false);
				toast.success("通知設定を追加しました。");
				return;
			}
			toast.error("通知設定の追加に失敗しました。");
		},
		[handleMutate, handleCreate]
	);
	if (notifications === null || statuses === null) {
		return null;
	}
	return (
		<>
			<Grid>
				<Box>
					<h3 className={SettingStyles.SettingTitle}>通知設定</h3>
				</Box>
				<Box>
					<NotificationList
						handleDestroy={handleDestroy}
						handleMutate={handleMutate}
						handleUpdate={handleUpdate}
						notifications={notifications}
						statuses={statuses}
						subtypes={subtypes}
						type="CompanyNotification"
						useLineNotification={false}
					/>
				</Box>
				<Box marginTop={8}>
					<Button
						onClick={() => {
							setIsNotificationModalOpen(true);
						}}
						variant="secondary"
					>
						通知設定の追加
					</Button>
				</Box>
			</Grid>
			{isNotificationModalOpen ? (
				<NotificationModal
					handleAcceptSubmit={handleAcceptSubmit}
					handleClose={() => {
						setIsNotificationModalOpen(false);
					}}
					lineUserAccounts={null}
					statuses={statuses}
					subtypes={subtypes}
					type="CompanyNotification"
					useLineNotification={false}
				/>
			) : null}
		</>
	);
};
